import $ from 'jquery';

export default class Maps {
    constructor() {
        if ($('.google-map').length > 0) {
            var GoogleMapsLoader = require('google-maps');
            GoogleMapsLoader.KEY = 'AIzaSyBsPOqU2d9UJ_Vvu0DNOi5osaT45e7dsGg';
            GoogleMapsLoader.LANGUAGE = 'de';
            GoogleMapsLoader.REGION = 'AT';

            console.log('inside google map method');
            GoogleMapsLoader.load(function (google) {
                var options = {
                    zoom: 13,
                    center: { lat: 47.7483381, lng: 13.0072463 },
                    mapTypeControl: true,
                    mapTypeControlOptions: {
                        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                        mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.TERRAIN, 'styled_map'],
                    },
                };

                var styledMapType = new google.maps.StyledMapType(
                    [
                        {
                            featureType: 'administrative',
                            elementType: 'geometry.fill',
                            stylers: [
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'administrative',
                            elementType: 'geometry.stroke',
                            stylers: [
                                {
                                    color: '#6e3a35',
                                },
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'administrative',
                            elementType: 'labels.text.fill',
                            stylers: [
                                {
                                    color: '#6e3a35',
                                },
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'administrative',
                            elementType: 'labels.text.stroke',
                            stylers: [
                                {
                                    visibility: 'on',
                                },
                            ],
                        },
                        {
                            featureType: 'administrative.locality',
                            elementType: 'labels.icon',
                            stylers: [
                                {
                                    color: '#6e3a35',
                                },
                                {
                                    saturation: '0',
                                },
                                {
                                    visibility: 'on',
                                },
                            ],
                        },
                        {
                            featureType: 'landscape',
                            elementType: 'geometry.fill',
                            stylers: [
                                {
                                    color: '#efebea',
                                },
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'landscape',
                            elementType: 'geometry.stroke',
                            stylers: [
                                {
                                    color: '#af9d94',
                                },
                                {
                                    saturation: '0',
                                },
                                {
                                    visibility: 'off',
                                },
                            ],
                        },
                        {
                            featureType: 'landscape',
                            elementType: 'labels.text.fill',
                            stylers: [
                                {
                                    color: '#6e3a35',
                                },
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'landscape',
                            elementType: 'labels.text.stroke',
                            stylers: [
                                {
                                    visibility: 'off',
                                },
                            ],
                        },
                        {
                            featureType: 'landscape.man_made',
                            elementType: 'geometry.fill',
                            stylers: [
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'poi',
                            elementType: 'geometry',
                            stylers: [
                                {
                                    hue: '#ff0000',
                                },
                                {
                                    saturation: '34',
                                },
                            ],
                        },
                        {
                            featureType: 'poi',
                            elementType: 'labels.text.fill',
                            stylers: [
                                {
                                    color: '#6e3a35',
                                },
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'poi.business',
                            stylers: [{ visibility: 'on' }],
                        },
                        {
                            featureType: 'poi',
                            elementType: 'labels.text.stroke',
                            stylers: [
                                {
                                    visibility: 'on',
                                },
                            ],
                        },
                        {
                            featureType: 'poi',
                            elementType: 'labels.icon',
                            stylers: [
                                {
                                    visibility: 'on',
                                },
                            ],
                        },
                        {
                            featureType: 'road',
                            elementType: 'geometry.stroke',
                            stylers: [
                                {
                                    visibility: 'off',
                                },
                            ],
                        },
                        {
                            featureType: 'road',
                            elementType: 'labels.text.fill',
                            stylers: [
                                {
                                    color: '#6e3a35',
                                },
                            ],
                        },
                        {
                            featureType: 'road',
                            elementType: 'labels.text.stroke',
                            stylers: [
                                {
                                    visibility: 'on',
                                },
                            ],
                        },
                        {
                            featureType: 'road',
                            elementType: 'labels.icon',
                            stylers: [
                                {
                                    visibility: 'off',
                                },
                                {
                                    lightness: '60',
                                },
                                {
                                    gamma: '1.00',
                                },
                                {
                                    hue: '#ff0000',
                                },
                                {
                                    saturation: '-90',
                                },
                            ],
                        },
                        {
                            featureType: 'road.highway',
                            elementType: 'geometry.fill',
                            stylers: [
                                {
                                    color: '#ffffff',
                                },
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'road.highway',
                            elementType: 'labels.icon',
                            stylers: [
                                {
                                    visibility: 'simplified',
                                },
                                {
                                    hue: '#ff0000',
                                },
                                {
                                    weight: '0.01',
                                },
                            ],
                        },
                        {
                            featureType: 'transit',
                            elementType: 'geometry.fill',
                            stylers: [
                                {
                                    color: '#bfb1a9',
                                },
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'transit',
                            elementType: 'geometry.stroke',
                            stylers: [
                                {
                                    color: '#bfb1a9',
                                },
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'transit',
                            elementType: 'labels.text.fill',
                            stylers: [
                                {
                                    color: '#6e3a35',
                                },
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'transit',
                            elementType: 'labels.text.stroke',
                            stylers: [
                                {
                                    visibility: 'off',
                                },
                            ],
                        },
                        {
                            featureType: 'transit',
                            elementType: 'labels.icon',
                            stylers: [
                                {
                                    visibility: 'on',
                                },
                                {
                                    hue: '#ff0000',
                                },
                                {
                                    saturation: '-90',
                                },
                                {
                                    lightness: '0',
                                },
                                {
                                    gamma: '1.00',
                                },
                                {
                                    weight: '1',
                                },
                            ],
                        },
                        {
                            featureType: 'water',
                            elementType: 'all',
                            stylers: [
                                {
                                    color: '#dfd8d4',
                                },
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'water',
                            elementType: 'labels.text',
                            stylers: [
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'water',
                            elementType: 'labels.text.fill',
                            stylers: [
                                {
                                    color: '#6e3a35',
                                },
                                {
                                    saturation: '0',
                                },
                            ],
                        },
                        {
                            featureType: 'water',
                            elementType: 'labels.text.stroke',
                            stylers: [
                                {
                                    visibility: 'off',
                                },
                            ],
                        },
                        {
                            featureType: 'water',
                            elementType: 'labels.icon',
                            stylers: [
                                {
                                    visibility: 'off',
                                },
                            ],
                        },
                    ],
                    { name: 'Stilisierte Karte' }
                );

                var map = new google.maps.Map($('.google-map').get(0), options);

                var image = {
                    size: new google.maps.Size(40, 60),
                    url: '/_Resources/Static/Packages/GesagtGetan.MayrmelnhofAt/Images/Icons/Marker.png',
                };

                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(47.74826858, 13.0072921),
                    icon: image,
                    map: map,
                });

                //Associate the styled map with the MapTypeId and set it to display.
                map.mapTypes.set('styled_map', styledMapType);
                map.setMapTypeId('styled_map');
            });
        }
    }
}
